import React, { useState } from 'react';

const DOCUMENT_TYPES = [
    { code: 'D001', name: 'Key Shareholder/Investor Documents' },
    { code: 'D002', name: 'Commercial Activities' },
    { code: 'D003', name: 'Legal' },
    { code: 'D004', name: 'Property' },
    { code: 'D005', name: 'Intellectual Property' },
    { code: 'D006', name: 'Insurance' },
    { code: 'D007', name: 'Corporate Structure' },
    { code: 'D008', name: 'Financial Information' },
    { code: 'D009', name: 'Employment & HR' },
    { code: 'D010', name: 'Regulatory & Compliance' },
    { code: 'DXXX', name: 'Other / Unallocated' }
];

const ClassificationConfirm = ({ classification, onConfirm, onDismiss }) => {
    const [showCorrection, setShowCorrection] = useState(false);
    const [selectedCode, setSelectedCode] = useState(classification?.['suggestedSectionCode'] || '');
    const [selectedType, setSelectedType] = useState(classification?.['documentType'] || '');

    if (!classification) return null;

    const confidencePercent = Math.round((classification['confidence'] || 0) * 100);
    const fileName = classification['fileName'] || classification['fileUrl']?.split('/').pop() || 'Document';

    const handleConfirm = () => {
        onConfirm(true);
    };

    const handleCorrect = () => {
        onConfirm(false, selectedType, selectedCode);
    };

    return (
        <div className="clarence-modal-overlay">
            <div className="clarence-classification-modal">
                <div className="modal-header">
                    <h3>Document Classification</h3>
                    <button className="modal-close" onClick={onDismiss}>×</button>
                </div>

                <div className="modal-body">
                    <div className="document-preview">
                        <div className="document-icon">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="#6366f1" strokeWidth="2"/>
                                <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="#6366f1" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="document-info">
                            <p className="document-name">{fileName}</p>
                        </div>
                    </div>

                    <div className="classification-result">
                        <p>Clarence thinks this document is:</p>
                        <div className="suggested-type">
                            <strong>{classification['documentType']}</strong>
                            <span className="confidence-badge" style={{ backgroundColor: confidencePercent > 70 ? '#10b981' : '#f59e0b' }}>
                                {confidencePercent}% confident
                            </span>
                        </div>
                        <p className="section-code">Section: {classification['sectionCode']} - {classification['sectionName']}</p>
                        {classification['reasoning'] && (
                            <p className="reasoning">{classification['reasoning']}</p>
                        )}
                    </div>

                    {!showCorrection ? (
                        <div className="modal-actions">
                            <button className="btn-confirm" onClick={handleConfirm}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                                Yes, that's correct
                            </button>
                            <button className="btn-correct" onClick={() => setShowCorrection(true)}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2"/>
                                    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2"/>
                                </svg>
                                No, let me correct
                            </button>
                        </div>
                    ) : (
                        <div className="correction-form">
                            <label>Select the correct section:</label>
                            <select value={selectedCode} onChange={(e) => setSelectedCode(e.target.value)}>
                                <option value="">-- Select Section --</option>
                                {DOCUMENT_TYPES.map(dt => (
                                    <option key={dt.code} value={dt.code}>{dt.code} - {dt.name}</option>
                                ))}
                            </select>

                            <label>Document type (optional):</label>
                            <input type="text" value={selectedType} onChange={(e) => setSelectedType(e.target.value)} placeholder="e.g., Pitch Deck, Board Minutes" />

                            <div className="modal-actions">
                                <button className="btn-cancel" onClick={() => setShowCorrection(false)}>Cancel</button>
                                <button className="btn-submit" onClick={handleCorrect} disabled={!selectedCode}>
                                    Submit Correction
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ClassificationConfirm;
